import { activeTabActions } from '../../services';

export const activeTabReducer = ( state = { selector: 'Products' }, action ) => {
  switch ( action.type ) {
    case activeTabActions.SET:
      return Object.assign( {}, state, { [action.title]: action.tab } );
    default:
      return state;
  }
};
